export default __webpack_public_path__ + "static/media/iphone13.308171b7.png";